﻿declare var require: any;
import mixitup from 'mixitup';
import mixitupMultifilter from 'mixitupMultifilter';
import mixitupPagination from 'mixitupPagination';

mixitup.use(mixitupMultifilter);
mixitup.use(mixitupPagination);

export function render() {
  var widthWindow = window.innerWidth;
  var containerEl = document.querySelector('.mixContainer');
  var selectFilter = document.getElementById('fieldSelect') as HTMLInputElement;
  var locationSort = document.getElementById(
    'locationSelect'
  ) as HTMLInputElement;
  var orderLocation = '';
  var selector = '';
  var activePage = 1;
  var activeLimit = 8;
  var order = 1;

  if (containerEl != null) {
    var mixer = mixitup(containerEl, {
      animation: {
        duration: 0,
      },
      multifilter: {
        enable: true,
      },
      behavior: {
        liveSort: true,
      },
      pagination: {
        limit: activeLimit,
        hidePageListIfSinglePage: true,
      },
      callbacks: {
        onMixEnd: function (state: {
          activePagination: { limit: number; page: number };
        }) {
          if (
            state.activePagination.limit === activeLimit &&
            state.activePagination.page === activePage
          )
            return;

          activePage = state.activePagination.page;
          activeLimit = state.activePagination.limit;

          paginationCallback();
        },
      },
    });

    locationSort.addEventListener('change', function () {
      orderLocation = locationSort.value;
      mixer.filter(orderLocation);
    });

    selectFilter.addEventListener('change', function () {
      selector = selectFilter.value;
      mixer.filter(selector);
    });

    var pages = document.querySelector('.mixitup-page-list');

    if (pages !== null) {
      for (var i = 0; i < pages.children.length; i++) {
        if (pages.children[i].classList.contains('mixitup-control-prev')) {
          pages.children[i].innerHTML = 'Föregående';
        } else if (
          pages.children[i].classList.contains('mixitup-control-next')
        ) {
          pages.children[i].innerHTML = 'Nästa';
        }
      }
    }
  }

  let fileInput = <HTMLInputElement>document.getElementById('file-input');

  if (fileInput != null) {
    fileInput.addEventListener('change', function (evnt) {
      const fileList: string[] = [];

      var files = '';
      if (fileInput.files != null) {
        for (var i = 0; i < fileInput.files.length; i++) {
          fileList.push(fileInput.files[i].name);

          if (i < fileInput.files.length - 1) {
            files += fileInput.files[i].name + ',' + ' ';
          } else {
            files += fileInput.files[i].name;
          }
        }
      }

      // $(this).parent(".file-upload-wrapper").attr("data-text", files);
      const parentElementUploadFile = this.parentElement;
      if (
        parentElementUploadFile != null &&
        parentElementUploadFile.classList.contains('file-upload-wrapper')
      ) {
        parentElementUploadFile.setAttribute('data-text', files);
      }
    });
  }

  let fileInputLetter = <HTMLInputElement>(
    document.getElementById('file-input-letter')
  );

  if (fileInputLetter != null) {
    fileInputLetter.addEventListener('change', function (evnt) {
      const fileListLetter: string[] = [];

      var files = '';
      var inputLetterFiles = fileInputLetter.files;
      if (inputLetterFiles != null) {
        for (var i = 0; i < inputLetterFiles.length; i++) {
          fileListLetter.push(inputLetterFiles[i].name);

          if (i < inputLetterFiles.length - 1) {
            files += inputLetterFiles[i].name + ',' + ' ';
          } else {
            files += inputLetterFiles[i].name;
          }
        }
      }
      const parentElementUpload = this.parentElement;
      if (
        parentElementUpload != null &&
        parentElementUpload.classList.contains('file-upload-wrapper')
      ) {
        parentElementUpload.setAttribute('data-text', files);
      }
    });
  }

  /* GET ALL JOBS */
  var location = '';
  var allLocations: any[] = [];
  var mixCategories: any[] = [];

  function getAllJobs() {
    var documentHead = document.querySelector('head');

    //ENSKILD JOBBSIDA
    if (document.getElementById('VacantJob') != null) {
      var str = window.location.search;
      var splitStr = str.split('&');
      var urlId = 0;

      for (var i = 0; i < splitStr.length; i++) {
        if (splitStr[i].indexOf('s=') > -1) {
          urlId = parseInt(splitStr[i].replace('s=', ''));
        }
      }

      urlId = Number(urlId);

      if (urlId != 0) {
        var fetchUrl =
          'https://feed.jobylon.com/feeds/699db87514474b99bdd1ffa2fa648d87/' +
          urlId +
          '/?format=json';
        fetch(fetchUrl)
          .then((response) => response.json())
          .then((result) => {
            var field = result;
            if (
              field.id == urlId &&
              field.title != null &&
              field.title.length > 0
            ) {
              var heroMainTitle = document.querySelector('.hero-main-title');
              var currentBreadcrumb = document.querySelector(
                '.current-page-breadcrumb'
              );
              if (heroMainTitle !== null) {
                heroMainTitle.textContent = field.title;
                if (currentBreadcrumb != null) {
                  currentBreadcrumb.textContent = field.title;
                }
                var metaTitle = field.title;
                document.head.innerHTML +=
                  '<meta property="og:title" content="' + metaTitle + '">';
              }
              var heroImage = document.getElementById('jobImage');

              document.head.insertAdjacentHTML(
                'beforeend',
                '<meta property="og:url" content="' +
                  window.location.href +
                  '">'
              );

              var link = document.querySelector('link[rel="canonical"]');
              if (link) {
                link.setAttribute('href', window.location.href);
              }

              var metaMainDescription = '';

              if (heroImage != null && field.company.cover != null) {
                var jobImage = document.getElementById(
                  'jobImage'
                ) as HTMLImageElement;
                jobImage.src = field.company.cover;
                jobImage.alt = field.title;
                var metaImage = field.company.cover;
                if (documentHead != null) {
                  documentHead.insertAdjacentHTML(
                    'beforeend',
                    '<meta property="og:image" content =' + metaImage + '>'
                  );
                }
              } else if (heroImage != null) {
                heroImage.setAttribute(
                  'style',
                  'background-image:url("/Images/bostadskoll.jpg?width=1900")'
                );
              }
              if (
                field.locations != null &&
                field.locations.length == 1 &&
                field.locations[0].location.city != undefined
              ) {
                location = field.locations[0].location.city;

                if (allLocations.length == 0) {
                  allLocations.push(location);
                } else {
                  if (allLocations.indexOf(location) == -1) {
                    allLocations.push(location);
                    allLocations.sort();
                  }
                }
              } else if (
                field.locations != null &&
                field.locations.length > 1
              ) {
                for (i = 0; i < field.locations.length; i++) {
                  if (location.length > 0) {
                    location += ', ' + field.locations[i].location.city;
                  } else {
                    location = field.locations[i].location.city;
                  }
                  if (allLocations.length == 0) {
                    allLocations.push(field.locations[i].location.city);
                  } else {
                    if (
                      allLocations.indexOf(field.locations[i].location.city) ==
                      -1
                    ) {
                      allLocations.push(field.locations[i].location.city);
                      allLocations.sort();
                    }
                  }
                }
              }
              if (field.descr.length > 0) {
                var jobDesc = document.getElementById('job-desc');
                if (jobDesc != null) {
                  jobDesc.innerHTML = field.descr;
                }
                metaMainDescription = field.descr;
                metaMainDescription = metaMainDescription.replace(
                  /<[^>]*>?/gm,
                  ''
                );

                var descriptionTag = document.createElement('meta');
                var urlTag = document.createElement('meta');

                descriptionTag.name = 'description';
                urlTag.name = 'url';
                descriptionTag.content = metaMainDescription;
                urlTag.content = 'url';
                if (documentHead != null) {
                  documentHead.insertAdjacentHTML(
                    'beforeend',
                    '<meta property="og:description" content =' +
                      metaMainDescription +
                      '>'
                  );
                }
              }
              var exp =
                /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;
              var officeLink = field.departments[0].department.descr.match(exp);
              if (field.categories[0].category.id != null) {
                if (field.categories[0].category.id == 759) {
                  var applyOther = document.getElementById('apply');
                  if (applyOther != null) {
                    applyOther.classList.add('other-form');
                  }
                }
              }
              var officeLinkDiv = document.getElementById('office-link');
              if (officeLinkDiv != null && officeLink != null) {
                if (officeLinkDiv.children.length == 0) {
                  var officeLinkElement = document.createElement('a');
                  officeLinkElement.innerHTML = 'Besök bobutik';
                  officeLinkElement.setAttribute('href', officeLink);
                  officeLinkElement.classList.add(
                    'text-center',
                    'block',
                    'rounded-md',
                    'w-full',
                    'font-icb',
                    'rounded-md',
                    'hover-blue-border',
                    'text-blue700',
                    'border-2',
                    'border-blue700',
                    'py-3',
                    'px-4'
                  );
                  document
                    .getElementById('office-link')
                    ?.appendChild(officeLinkElement);
                }
              } else if (officeLink == null) {
                document.getElementById('office-link')?.remove();
                document.querySelector('.or-span')?.remove();
              }
              var contactPhone = document.getElementById('contact-phone');
              var contactName = document.getElementById('contact-card-name');
              var contactEmail = document.getElementById('contact-email');
              var applyDateContainer = document.getElementById('apply-date');
              if (field.contact.name != null && contactName != null) {
                contactName.innerHTML = field.contact.name;
              }
              if (
                field.contact.phone != null &&
                field.contact.phone != '' &&
                contactPhone != null
              ) {
                var phoneNo = field.contact.phone.replace(/ /g, '');
                contactPhone.innerHTML =
                  "<a class='" +
                  'font-icb text-blue700 flex items-center justify-center' +
                  "' href=tel:" +
                  phoneNo +
                  '>' +
                  field.contact.phone +
                  '</a>';
              } else {
                contactPhone?.remove();
              }
              if (
                field.contact.email != null &&
                field.contact.email != '' &&
                contactEmail != null
              ) {
                contactEmail.innerHTML =
                  "<a class='" +
                  'font-icb items-center flex justify-center' +
                  "' href=mailto:" +
                  field.contact.email +
                  '>' +
                  'Maila ' +
                  field.contact.name +
                  '</a>';
              } else {
                contactEmail?.remove();
              }
              if (field.contact.phone == '' && field.contact.email == '') {
                document.querySelector('.contact-card-img')?.remove();
              }
              if (field.contact.photo != null) {
                var contactImage = document.getElementById('contact-image');
                var contactPerson = document.createElement('img');
                contactImage?.setAttribute(
                  'style',
                  'background-image:url(' +
                    '' +
                    field.contact.photo +
                    '?width=200&height=200&mode=crop&quality=80)'
                );
                contactPerson.src =
                  field.contact.photo +
                  '?width=200&height=200&mode=crop&quality=80';
                contactPerson.classList.add('max-w-full');
              } else if (field.contact.photo == null) {
                var contactImage = document.getElementById('contact-image');
                contactImage?.setAttribute(
                  'style',
                  'background-image:url("/Images/fallbacks/placeholder-photo.jpg")'
                );
              }
              if (field.to_date != null && applyDateContainer != null) {
                applyDateContainer.innerHTML = field.to_date;
              }
              var jobCity = document.getElementById('job-city');
              if (
                allLocations != null &&
                allLocations.length > 0 &&
                field.locations.length > 0 &&
                jobCity != null
              ) {
                jobCity.innerHTML = location;
              } else {
                jobCity?.parentElement?.remove();
              }
            }
          });
      }
    }
    //LEDIGA TJÄNSTER ELLER MÖJLIGHETER
    else if (
      document.getElementById('vacancies-ul') != null ||
      document.getElementById('VacantJobs') != null ||
      document.getElementById('CareerPossibility') != null
    ) {
      // var urlId = 0;

      fetch(
        'https://feed.jobylon.com/feeds/699db87514474b99bdd1ffa2fa648d87/?format=json'
      )
        .then((response) => response.json())
        .then((result) => {
          var ul = document.getElementById('vacancies-ul');
          var typeSelectDropdown = document.getElementById('fieldSelect');
          var locationSelectDropdown =
            document.getElementById('locationSelect');
          var jobCount = 1;
          var jobDescription = '';
          var resultCount = 0;
          var applyDate = '';
          var applyButton = '';

          result.forEach(function (field: any, i: number) {
            if (field.id != 1772 && field.id != 27266 && !ulCheck(field.id)) {
              resultCount++;
              var fromDate = field.from_date;
              var locationIcon = '';

              location = '';
              var li = document.createElement('li');
              li.setAttribute('id', 'vacancy');
              li.classList.add(
                'mix',
                'w-full',
                'block',
                'overflow-hidden',
                'mb-4',
                'shadow-bs40',
                'hover:shadow-bs60',
                'focus-within:ring-2',
                'focus-within:ring-blue400',
                'focus-within:ring-offset-2',
                field.id
              );

              if (
                field.locations != null &&
                field.locations.length == 1 &&
                field.locations[0].location.city != undefined
              ) {
                li.classList.add(
                  field.locations[0].location.city
                    .toLowerCase()
                    .replace(/ä/g, 'a')
                    .replace(/å/g, 'a')
                    .replace(/ö/g, 'o')
                    .replace('/', '-')
                    .replace(/ /g, '-')
                );
                location = field.locations[0].location.city;

                if (allLocations.length == 0) {
                  allLocations.push(location);
                } else {
                  if (allLocations.indexOf(location) == -1) {
                    allLocations.push(location);
                    allLocations.sort();
                  }
                }
              } else if (
                field.locations != null &&
                field.locations.length > 1
              ) {
                for (i = 0; i < field.locations.length; i++) {
                  li.classList.add(
                    field.locations[i].location.city
                      .toLowerCase()
                      .replace(/ä/g, 'a')
                      .replace(/å/g, 'a')
                      .replace(/ö/g, 'o')
                      .replace('/', '-')
                      .replace(/ /g, '-')
                  );

                  if (location.length > 0) {
                    location += ', ' + field.locations[i].location.city;
                  } else {
                    location = field.locations[i].location.city;
                  }
                  if (allLocations.length == 0) {
                    allLocations.push(field.locations[i].location.city);
                  } else {
                    if (
                      allLocations.indexOf(field.locations[i].location.city) ==
                      -1
                    ) {
                      allLocations.push(field.locations[i].location.city);
                      allLocations.sort();
                    }
                  }
                }
              }

              li.setAttribute('data-edited', fromDate);
              li.setAttribute('data-order', order.toString());

              if (location.length != 0 && widthWindow > 735) {
                locationIcon =
                  "<img class='mr-3 w-full max-w-5 self-center' src='/Images/Icons/location.svg' srcset ='/Images/Icons/location.svg 1.5x' width='20' height='20' loading='lazy' alt = 'Location icon'>";
              }

              if (field.to_date != null && widthWindow > 735) {
                applyDate =
                  "<div class='flex items-center w-full'><img class='mr-3 w-full max-w-5 self-center' src='/Images/Icons/calendar.svg' srcset ='/Images/Icons/calendar.svg 1.5x' width='20' height='20' loading='lazy' alt = 'Calendar icon'><span class='text-tiny text-black700'>" +
                  field.to_date +
                  '</span></div>';
              } else if (widthWindow > 767) {
                applyDate =
                  "<div class='flex items-center w-full'><img class='mr-3 w-full max-w-5 self-center' src='/Images/Icons/calendar.svg' width='20' height='20' srcset ='/Images/Icons/calendar.svg 1.5x' loading='lazy' alt = 'Calendar icon'>" +
                  '<span class="text-tiny text-black700">Urval sker löpande</span></div>';
              }

              if (
                field.descr != null &&
                field.descr.length > 200 &&
                widthWindow > 735
              ) {
                jobDescription = field.descr;
                jobDescription = jobDescription.slice(0, 150) + '...';
                jobDescription = jobDescription.replace(
                  /(<p[^>]+?>|<p>|<\/p>|<strong>|<\/strong>)/gim,
                  ''
                );
              } else if (field.descr != null && widthWindow > 735) {
                jobDescription = field.descr;
              }

              if (widthWindow < 736) {
                applyButton =
                  "<div class='" +
                  'mt-2 text-grey400 flex items-center' +
                  "'><span>Läs mer och ansök</span> <img class='ml-3 inline-block w-4.5' src='/Images/Icons/Arrows/arrow-right-line-black500.svg' srcset ='/Images/Icons/Arrows/arrow-right-line-black500.svg 1.5x' loading='lazy' alt = 'Circle icon'></div>";
              }
              li.innerHTML =
                "<a onclick='" +
                'pushGtmJob(' +
                '"' +
                'Läs mer och ansök' +
                '"' +
                ',' +
                '"' +
                '/jobba-med-oss/lediga-tjanster/ledig-tjanst/?' +
                field.slug +
                '&' +
                's=' +
                field.id +
                '"' +
                ')' +
                "' id='job-link' class='" +
                'flex-col mdplus:flex-row vacancy-title p-4 px-4 lg:px-8 flex justify-between bg-white rounded-md' +
                "' href='" +
                '/jobba-med-oss/lediga-tjanster/ledig-tjanst/?' +
                field.slug +
                '&' +
                's=' +
                field.id +
                "'><div class='" +
                'mdplus:self-center mr-2' +
                "'><h4 class='text-lg text-blue700 font-icb mb-1 lg:mb-2'>" +
                field.title +
                "</h4><div class='" +
                'job-preamble max-w-xl' +
                "'>" +
                "<p class='" +
                'text-ic m-0 pr-4' +
                "' + >" +
                jobDescription +
                '</p></div></div>' +
                ' ' +
                "<div class='" +
                'flex flex-col mdplus:max-w-micro mdplus:w-1/4 justify-center' +
                "'><div class='" +
                'vacancy-city block flex items-center text-black700 lg:mb-4 mdplus:mb-3 mdplus:text-tiny' +
                "'>" +
                locationIcon +
                '<span>' +
                location +
                "</span></div><span class='" +
                'apply-date block flex align-center mdplus:text-tiny lg:text-base' +
                "'>" +
                applyDate +
                '</span>' +
                applyButton +
                '</div>';
              if (li != null && ul != null) {
                var referenceElement = mixer.getState().show[1];
                order++;
                mixer.insertBefore(li, referenceElement);

                var currentJob = 'job' + jobCount;
                currentJob = currentJob.toString();

                jobCount++;
                mixer.sort('order:asc');
              }

              if (mixCategories.length >= 1 && field.categories.length > 0) {
                if (field.categories.length > 0) {
                  for (i = 0; i < field.categories.length; i++) {
                    var currentCategory = field.categories[i].category.text
                      .toLowerCase()
                      .replace(/ä/g, 'a')
                      .replace(/å/g, 'a')
                      .replace(/ö/g, 'o')
                      .replace('/', '-');
                    li.classList.add(currentCategory);

                    if (
                      mixCategories.indexOf(
                        field.categories[i].category.text
                      ) == -1
                    ) {
                      mixCategories.push(field.categories[i].category.text);
                      mixCategories.sort();
                    }
                  }
                }
              } else if (mixCategories.length < 1) {
                if (field.categories.length > 0) {
                  for (i = 0; i < field.categories.length; i++) {
                    var currentCategory = field.categories[i].category.text
                      .toLowerCase()
                      .replace(/ä/g, 'a')
                      .replace(/å/g, 'a')
                      .replace(/ö/g, 'o')
                      .replace('/', '-');
                    li.classList.add(currentCategory);

                    if (
                      mixCategories.indexOf(
                        field.categories[i].category.text
                      ) == -1
                    ) {
                      mixCategories.push(field.categories[i].category.text);
                      mixCategories.sort();
                    }
                  }
                }
              }
            }
            //MÖJLIGHETER
            if (document.getElementById('CareerPossibility') != null) {
              var biddingBlockId;
              var possibilityChildElements;

              var possibilityInfo = document.getElementById('possibility-info');
              if (possibilityInfo != null) {
                possibilityChildElements = possibilityInfo.childElementCount;
              }
              var biddingBlock = document.querySelector(
                '.biddingBlock'
              ) as HTMLDivElement;

              if (biddingBlock != null) {
                biddingBlockId = biddingBlock.id;
              }
              var fieldCategories = field.categories;
              var fieldCategory = '';
              for (i = 0; i < fieldCategories.length; i++) {
                fieldCategory =
                  fieldCategory +
                  ' ' +
                  fieldCategories[i].category.id
                    .toString()
                    .toLowerCase()
                    .replace(/ä/g, 'a')
                    .replace(/å/g, 'a')
                    .replace(/ö/g, 'o');
              }

              if (possibilityChildElements != null) {
                if (
                  fieldCategory.includes(biddingBlockId) &&
                  possibilityInfo != null &&
                  possibilityInfo.childElementCount < 2
                ) {
                  var possibilityUl = possibilityInfo;
                  var possibleLi = document.createElement('li');

                  if (location.length != 0 && widthWindow > 767) {
                    locationIcon =
                      "<div class='vacancy-city mt-3 flex items-center text-grey400 mdplus:text-black500 mdplus:text-base'><img class='mr-3 w-full max-w-5 self-center' src='/Images/Icons/location.svg' srcset ='/Images/Icons/location.svg 1.5x' width='20' height='20' loading='lazy' alt = 'Location icon'><span>" +
                      location +
                      '</span></div>';
                  } else {
                    locationIcon = '';
                  }
                  possibleLi.setAttribute('id', 'vacant-position');
                  possibleLi.innerHTML =
                    "<a class='" +
                    'flex-col p-4 px-4 lg:px-8 flex' +
                    "' href='" +
                    '/jobba-med-oss/lediga-tjanster/ledig-tjanst/?' +
                    field.slug +
                    '&' +
                    's=' +
                    field.id +
                    "'><div class='" +
                    "'><h4 class='hover:underline text-lg text-blue700 hover:text-blue700 font-icb mb-1-'>" +
                    field.title +
                    '</h4>' +
                    locationIcon +
                    "<div class='text-black500 apply-date block items-center mt-3 mdplus:text-base'>" +
                    applyDate +
                    '</div>' +
                    applyButton +
                    '</div>';

                  if (possibilityUl != null) {
                    possibilityUl.appendChild(possibleLi);
                  }
                }
              }
            }
          });

          if (
            resultCount > 0 &&
            document.querySelector('.vacancy-number') != null
          ) {
            var vacancyCount = document.querySelector('.vacancy-count');
            var vacancyNumber = document.querySelector('.vacancy-number');
            if (vacancyCount != null) {
              vacancyCount.innerHTML = 'Just nu har vi ';
            }
            if (vacancyNumber != null) {
              vacancyNumber.innerHTML = resultCount.toString();
            }
            var vacancyText = document.querySelector('.vacant-jobs-text');
            if (vacancyText != null) {
              if (resultCount == 1) {
                vacancyText.innerHTML = ' ledig tjänst';
              } else {
                vacancyText.innerHTML = ' lediga tjänster';
              }
            }
          }

          if (document.querySelector('.filter-button') != null) {
            for (var i = 0; i < mixCategories.length; i++) {
              var option = document.createElement('option');
              option.setAttribute(
                'data-filter',
                '.' +
                  mixCategories[i]
                    .toLowerCase()
                    .replace(/ä/g, 'a')
                    .replace(/å/g, 'a')
                    .replace(/ö/g, 'o')
              );
              option.setAttribute('data-mixitup-control', '');
              option.text = mixCategories[i];
              option.value =
                '.' +
                mixCategories[i]
                  .toLowerCase()
                  .replace(/ä/g, 'a')
                  .replace(/å/g, 'a')
                  .replace(/ö/g, 'o');

              if (typeSelectDropdown != null) {
                typeSelectDropdown.appendChild(option);
              }
            }
            for (i = 0; i < allLocations.length; i++) {
              var option = document.createElement('option');
              option.value =
                '.' +
                allLocations[i]
                  .toLowerCase()
                  .replaceAll(/ä/g, 'a')
                  .replaceAll(/å/g, 'a')
                  .replaceAll(/ö/g, 'o')
                  .replaceAll('/', '-')
                  .replaceAll();
              option.text = allLocations[i];

              var optionLi = document.createElement('option');
              var locationNameReplace = allLocations[i]
                .toLowerCase()
                .replace(/ä/g, 'a')
                .replace(/å/g, 'a')
                .replace(/ö/g, 'o')
                .replace('/', '-')
                .replace(/ /g, '-');

              optionLi.innerHTML = allLocations[i];
              optionLi.classList.add('filter');
              optionLi.setAttribute('data-mixitup-control', '');
              optionLi.setAttribute('value', '.' + locationNameReplace);
              optionLi.setAttribute('data-toggle', '.' + locationNameReplace);
              option.text = allLocations[i];
              option.value = '.' + locationNameReplace;

              if (locationSelectDropdown != null) {
                locationSelectDropdown.appendChild(optionLi);
              }
            }
          }
        });
    }
  }
  function ulCheck(fieldId: string) {
    var ul = document.getElementById('vacancies-ul');
    if (ul != null) {
      var ulList = ul.children;

      for (var i = 0; i < ulList.length; i++) {
        if (ulList[i].classList.contains(fieldId)) {
          return true;
        }
      }
    }
  }

  if (!document.querySelector('#VacantJob')) {
    var contactContainer = document.querySelectorAll('.contact-container');
    if (contactContainer.length > 0) {
      for (var i = 0; i < contactContainer.length; i++) {
        var brokerName = contactContainer[i].querySelector(
          '.broker-name'
        ) as HTMLDivElement;
        var parentContainer = contactContainer[i] as HTMLDivElement;
        if (brokerName != null) {
          parentContainer.style.maxHeight = brokerName.offsetHeight + 'px';
        }
      }
    }
  }

  if (
    document.getElementById('vacancies-ul') != null ||
    document.getElementById('VacantJobs') != null ||
    document.getElementById('VacantJob') != null ||
    document.getElementById('CareerPossibility') != null
  ) {
    getAllJobs();
  }
  var containerHeight = 0;
  var textcontentHeight = 0;

  document.querySelectorAll('.contact-content-slide').forEach(function (el) {
    el.addEventListener('click', function () {
      contactSlide(this);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        contactSlide(this);
      }
    });
  });

  document.querySelectorAll('.contact-card-back-img').forEach(function (el) {
    el.addEventListener('click', function () {
      contactBackSlide(this);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        contactBackSlide(this);
      }
    });
  });

  function contactSlide(e: any) {
    var contactContainer = e.closest('.contact-container');
    var contactTextContent = contactContainer.querySelector(
      '.contact-text-content'
    );

    if (contactContainer) {
      textcontentHeight = contactTextContent.offsetHeight;
      containerHeight = contactContainer.querySelector(
        '.contact-text-content'
      ).offsetHeight;
      contactTextContent.classList.toggle('translate-x-1/1-');

      if (contactContainer) {
        contactContainer.style.maxHeight = containerHeight + 'px';
      }
    }
  }

  function contactBackSlide(e: any) {
    var contactContainer = e.closest('.contact-container');
    var contactTextContent = contactContainer.querySelector(
      '.contact-text-content'
    ) as HTMLDivElement;
    var brokerContent = contactContainer.querySelector(
      '.broker-content'
    ) as HTMLDivElement;

    if (brokerContent == null) {
      brokerContent = document.querySelector('.broker-name') as HTMLDivElement;
    }
    containerHeight = brokerContent.clientHeight;

    if (contactContainer) {
      if (contactTextContent != null) {
        contactTextContent.classList.toggle('translate-x-1/1-');
      }
      contactContainer.style.maxHeight = containerHeight + 'px';
    }
  }
  function paginationCallback() {
    if (widthWindow > 1023) {
      window.scrollTo({
        top: 450,
        left: 0,
      });
    } else {
      window.scrollTo({
        top: 250,
        left: 0,
      });
    }
  }
  var filterContainer = document.querySelector('.filter-container');
  if (filterContainer != null) {
    const focusableSelectors =
      'a[href], button:not([disabled]), select, textarea, input, [tabindex]:not([tabindex="-1"])';

    var showJobsButton = document.querySelector('.show-jobs-button');
    var filterBtn = document.querySelector('.filter-button');
    var closeJobs = document.querySelector('.filter-jobs-close');

    let previouslyFocusedElement: HTMLElement | null = null;

    function trapFocus(container: HTMLElement) {
      const focusableElements = Array.from(
        container.querySelectorAll<HTMLElement>(focusableSelectors)
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      function handleKeyDown(e: KeyboardEvent) {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              e.preventDefault();
              lastElement.focus();
            }
          } else {
            if (document.activeElement === lastElement) {
              e.preventDefault();
              firstElement.focus();
            }
          }
        } else if (e.key === 'Escape') {
          closeFilter();
        }
      }

      container.addEventListener('keydown', handleKeyDown);
      firstElement?.focus();

      return () => {
        container.removeEventListener('keydown', handleKeyDown);
      };
    }

    let removeFocusTrap: (() => void) | null = null;

    function openFilter() {
      previouslyFocusedElement = document.activeElement as HTMLElement;
      filterContainer?.classList.remove('hidden', 'opacity-0');
      removeFocusTrap = trapFocus(filterContainer as HTMLElement);
    }

    function closeFilter() {
      filterContainer?.classList.add('opacity-0', 'hidden');
      if (removeFocusTrap) removeFocusTrap();
      if (previouslyFocusedElement) previouslyFocusedElement.focus();
    }

    filterContainer.addEventListener('click', function (e) {
      var target = e.target as HTMLElement;
      if (target.closest('.filter-options') == null) {
        closeFilter();
      }
    });

    closeJobs?.addEventListener('click', function () {
      closeFilter();
    });

    filterBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      openFilter();
    });

    showJobsButton?.addEventListener('click', function () {
      closeFilter();
    });
  }
}
